/*
 * @Author       : 蔡传明
 * @Date         : 2021-06-25 16:03:06
 * @LastEditors  : 蔡传明
 * @LastEditTime : 2021-08-20 16:55:47
 * @FilePath     : /club/src-client/container/404.tsx
 */
import * as React from 'react';

class NotFound

    extends React.PureComponent<any, any> {
    public render() {
        return (
            <div>
                <h1>页面不存在</h1>
            </div>
        );
    }
}

export default NotFound;
